import React from "react";
import { useDispatch } from "react-redux";
import { displayModal } from "actions/shared-actions";
import MembershipShippingAddress from "components/source/membership/membership-shipping-address";
import AtomLinkButton from "components/source/atoms/atom-link-button";
import KeepItForeverReturnsModal from "components/source/pdp/keep-it-forever-returns-modal";
import { analytics } from "rtr-constants";
import ActionLogger from "action-logger";
import { productPropType } from "components/propTypes";
import PropTypes from "prop-types";

const propTypes = {
  product: productPropType,
  hasAddress: PropTypes.bool,
  className: PropTypes.string,
};

const ShippingAndReturns = ({ product = {}, hasAddress = false, className = "" }) => {
  const dispatch = useDispatch();

  const openReturnsModal = () => {
    dispatch(displayModal(KeepItForeverReturnsModal.modalName));
    logReturnsModalAction();
  };

  const logReturnsModalAction = () => {
    const { id = null, purchasePrice = null, retailPrice = null } = product;

    ActionLogger.logAction({
      object_type: analytics.OBJECT_TYPE.RETURN_POLICY,
      action: analytics.ACTION_TYPE.CLICK,
      style: id,
      buy_price: purchasePrice,
      retail_price: retailPrice,
    });
  };

  return (
    <div className={className}>
      <p className="title">Shipping & Returns</p>
      <ul className="list-disc">
        {hasAddress && (
          <li>
            <MembershipShippingAddress />
          </li>
        )}
        <li>
          Return accepted within 7 days, restocking fee applies.{" "}
          <AtomLinkButton onClick={openReturnsModal} bold={false} className="returns-copy--cta">
            Learn More
          </AtomLinkButton>
        </li>
      </ul>
      <KeepItForeverReturnsModal />
    </div>
  );
};

ShippingAndReturns.propTypes = propTypes;
export default ShippingAndReturns;
